import type { FC } from 'react';

export const WhenToApplyQuote: FC<{ text: string | undefined }> = ({ text }) =>
    text?.trim() ? (
        <blockquote className="not-prose whitespace-pre-wrap border-l-4 border-slate-300 py-0.5 pl-3 text-sm">
            {text}
        </blockquote>
    ) : (
        <span className="text-sm text-muted-foreground">None</span>
    );
